import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        p: 3,
      }}
    >
      <Typography variant="h3" component="h1" gutterBottom>
        Oops! Algo salió mal.
      </Typography>
      <Typography variant="h6" component="p" gutterBottom>
        Lo sentimos, ha ocurrido un error inesperado.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleGoHome}
        sx={{ mt: 2 }}
      >
        Volver al Inicio
      </Button>
    </Box>
  );
};

export default ErrorPage;
